import { Component, OnInit, Output, Input, EventEmitter, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { carousaladdress } from '../../shared/shared.model'
import { NG_VALUE_ACCESSOR } from '@angular/forms';
@Component({
    // moduleId: module.id,
    selector: 'carousal',
    templateUrl: 'carousal.component.html',
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: CarousalComponent, multi: true }
    ],
    //changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarousalComponent implements OnInit {
    constructor() { }
    @Input() collections: carousaladdress[] = [];
    @Output() Event = new EventEmitter();
    @Input() header: string;
    @Input() id: string;
    @Input() isAdd: boolean = false;
    @Input() isEdit: boolean = false;
    @Input() selecteditem: number = 1;
    @Input() isHeader: boolean = true;
    current: number = 0;
    length: number = 0;
    isTick: number;
    Timer: any;
    excolcarousel: boolean = false;
    ngOnChanges(arg: any) {

        if (!this.collections) {
            this.collections = [];
        }
        this.length = this.collections.length;
        this.current = this.length > 0 ? this.selecteditem : 0;
    }
    ngOnInit() {

    }
    //Next Button click
    next() {
        if (this.current < this.collections.length) {
            var pid = this.current;
            var pelement = document.getElementById(this.id + "_" + pid);
            pelement.classList.remove('active')
            this.current += 1;
            var celement = document.getElementById(this.id + "_" + this.current);
            celement.classList.add('active');
            pelement.classList.remove('next')
            celement.classList.remove('next');
            this.Event.emit({ 'mode': "NEXT", 'id': this.collections[(this.current - 1)].primary, 'type': this.id, 'index': this.current });
        }
    }
    // select count Click
    select() {
        if (this.collections.length > 0 && this.isEdit)
            this.Event.emit({ 'mode': "SELECT", 'type': this.id, 'index': (this.current - 1) });
    }
    //Add carousal
    add() {
        this.Event.emit({ 'mode': "ADD", 'id': 0, 'type': this.id, 'index': this.current });
    }
    //Edit carousal
    edit(id: number) {
        debugger;
        this.Event.emit({ 'mode': "EDIT", 'id': this.collections.find(f => f.primary == id).primary, 'type': this.id, 'index': this.current });
    }
    // Prev Arrow Click
    prev() {
        if (this.current > 1) {
            this.current -= 1;
            this.Event.emit({ 'mode': "PREV", 'id': this.collections[this.current - 1].primary, 'type': this.id, 'index': this.current });
        }
    }
}